import { defineStore } from "pinia";
import { FrameMode } from "../enums/uiEnums";
import { IDialogueConfig } from "../composable/dialogue/types";
import { config as encounterStarConfig } from "../composable/dialogue/configs/encounter-star";
import { watchOnce } from "@vueuse/core";

export const useGameUI = defineStore("gameUI", {
  state: () => ({
    frameMode: FrameMode.FULL_SCREEN,
    dialogue: {
      isVisible: false,
      dialogueConfig: encounterStarConfig as IDialogueConfig | null,
    },
  }),
  getters: {
    isFreeMode: (state) =>
      state.frameMode === FrameMode.FULL_SCREEN_WITH_CONTROL ||
      state.frameMode === FrameMode.WITH_PANEL,
  },
  actions: {
    async showDialogue(config: IDialogueConfig) {
      await new Promise((resolve) => {
        this.dialogue.isVisible = true;
        this.dialogue.dialogueConfig = config;
        watchOnce(
          () => this.dialogue.isVisible,
          () => {
            if (!this.dialogue.isVisible) {
              resolve(true);
            }
          }
        );
      });
    },
    dialogueOver() {
      this.dialogue.isVisible = false;
    },
  },
});
